import { IconFlagFR } from '@components/icons/flag-fr';
import { IconFlagFRSmall } from '@components/icons/flag-fr-small';
import { IconFlagGB } from '@components/icons/flag-gb';
import { IconFlagGBSmall } from '@components/icons/flag-gb-small';
import { IconFlagIS } from '@components/icons/flag-is';
import { IconFlagISSmall } from '@components/icons/flag-is-small';
import { IconFlagNO } from '@components/icons/flag-no';
import { IconFlagNOSmall } from '@components/icons/flag-no-small';
import { IconFlagPL } from '@components/icons/flag-pl';
import { IconFlagPLSmall } from '@components/icons/flag-pl-small';
import { IconFlagSV } from '@components/icons/flag-sv';
import { IconFlagSVSmall } from '@components/icons/flag-sv-small';
import { CareerSiteLanguageType } from '@locale/locale-store';

const FLAG_SIZE = 24;

export const FLAG_MAPPER: { [key in CareerSiteLanguageType]: JSX.Element } = {
  en: <IconFlagGB />,
  is: <IconFlagIS />,
  pl: <IconFlagPL />,
  no: <IconFlagNO />,
  sv: <IconFlagSV />,
  fr: <IconFlagFR />,
};

export const FLAG_MAPPER_SMALL: { [key in CareerSiteLanguageType]: JSX.Element } = {
  en: <IconFlagGBSmall size={FLAG_SIZE} />,
  is: <IconFlagISSmall size={FLAG_SIZE} />,
  pl: <IconFlagPLSmall size={FLAG_SIZE} />,
  no: <IconFlagNOSmall size={FLAG_SIZE} />,
  sv: <IconFlagSVSmall size={FLAG_SIZE} />,
  fr: <IconFlagFRSmall size={FLAG_SIZE} />,
};
